import {
	EVENT_ACTION_REWARD_OFFERS_BANNER_TAP,
	EVENT_CATEGORY_ROYALTY_KPI,
	trackCustomEvent,
} from '../../../../shared/analytics';

export function trackRewardOffersBannerTap(screen: string) {
	trackCustomEvent({
		category: EVENT_CATEGORY_ROYALTY_KPI,
		action: EVENT_ACTION_REWARD_OFFERS_BANNER_TAP,
		screenName: screen,
	});
}
